export default __webpack_public_path__ + "static/work-progress-684684cc4b8c9341ea1d9b17a7970695.png";